<section class="p-2 px-md-4 py-md-3">
  <div class="heading-container">
    <div class="heading2">Send Quotation via Email</div>
    <div class="float-end close-icon" (click)="close()"><i class="fa-solid fa-xmark"></i></div>
  </div>
  <hr>
  <section>
    <form [formGroup]="sendQuotationForm">
      <div>
        <label class="field-label">Add Emails <span class="text-red">*</span></label>
        <mat-form-field class="example-chip-list w-100">
          <mat-chip-grid #chipGrid aria-label="Enter Emails" formControlName="emailList">
            <mat-chip-row *ngFor="let email of emailList" (removed)="remove(email)" [editable]="true"
              (edited)="edit(email, $event)" [aria-description]="'press enter to edit ' + email">
              {{email}}
              <button matChipRemove [attr.aria-label]="'remove ' + email">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
          </mat-chip-grid>
          <input placeholder="Add Emails..." type="email" [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="add($event)" />
        </mat-form-field>
        <div class="form-text">Please enter one or more email addresses, separated by commas. The system will send the
          quotation document to the provided email addresses.</div>
        <div *ngIf="submitted && sendQuotationForm.get('emailList')?.errors?.['required']"
          class="text-red small fw-bold">
          Email is required.
        </div>
        <div *ngIf="sendQuotationForm.get('emailList')?.errors?.['invalidEmails']" class="text-red small fw-bold">
          Some emails are invalid. Please correct them.
        </div>
      </div>
      <div class="text-center mt-4">
        <button class="primary-Button" (click)="submit()">Send <i class="fa-solid fa-arrow-right"></i></button>
      </div>
    </form>
  </section>
</section>